import { o } from "../../vendor-Dd6qj6gJ.js";
import { Alert as r } from "./Alert/index.js";
import { Content as m } from "./Content/index.js";
import { Drawer as t } from "./Drawer/index.js";
import { Footer as e } from "./Footer/index.js";
import { Heading as f } from "./Heading/index.js";
import { Modal as i } from "./Modal/index.js";
import { Popover as p } from "./Popover/index.js";
const s = { Alert: r, Content: m, Drawer: t, Footer: e, Heading: f, Modal: i, Popover: p, Trigger: o };
export {
  s as Dialog
};
